var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-slack",
    "data-name": "Icon awesome-slack",
    d: "M6.618,22.155a3.309,3.309,0,1,1-3.309-3.309H6.618Zm1.668,0a3.309,3.309,0,1,1,6.618,0v8.286a3.309,3.309,0,0,1-6.618,0ZM11.595,8.868A3.309,3.309,0,1,1,14.9,5.559V8.868H11.595Zm0,1.668a3.309,3.309,0,1,1,0,6.618H3.309a3.309,3.309,0,1,1,0-6.618h8.286Zm13.288,3.309a3.309,3.309,0,1,1,3.309,3.309H24.882Zm-1.668,0a3.309,3.309,0,0,1-6.618,0V5.559a3.309,3.309,0,0,1,6.618,0ZM19.905,27.132A3.309,3.309,0,1,1,16.6,30.441V27.132Zm0-1.668a3.309,3.309,0,0,1,0-6.618h8.286a3.309,3.309,0,0,1,0,6.618Z",
    transform: "translate(0 -2.25)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.51244b50cbbce4b302ac7edd6f7287c6.svg";
export { ForwardRef as ReactComponent };